// import apiDataSource from "@/api/main/dataSource/api/apiDataSourcemain";
import { ref } from "vue";
import BaseAdapterService from "@/pages/_adapter/BaseAdapterService";
import DashboardParametersRequest from "@/api/SchedulerAdmin/dataSource/api/scheduler/manager/serverless/i-services/models/dashboard/DashboardParametersRequest";
import DashboardParametersResponse from "@/api/SchedulerAdmin/dataSource/api/scheduler/manager/serverless/i-services/models/dashboard/DashboardParametersResponse";
import WsResponseModelT from "@/api/SchedulerAdmin/dataSource/api/schema-builder/server/models/WsResponseModelT";
import JobsTimelineRequest from "@/api/SchedulerAdmin/dataSource/api/scheduler/manager/serverless/i-services/models/dashboard/JobsTimelineRequest";
import JobsTimelineResponse from "@/api/SchedulerAdmin/dataSource/api/scheduler/manager/serverless/i-services/models/dashboard/JobsTimelineResponse";
import GetStatusHistoriesRequest from "@/api/SchedulerAdmin/dataSource/api/scheduler/manager/serverless/i-services/models/jobs/histories/status/GetStatusHistoriesRequest";
import GetStatusHistoriesResponse from "@/api/SchedulerAdmin/dataSource/api/scheduler/manager/serverless/i-services/models/jobs/histories/status/GetStatusHistoriesResponse";
import JobsLastErrorsResponse from "@/api/SchedulerAdmin/dataSource/api/scheduler/manager/serverless/i-services/models/dashboard/JobsLastErrorsResponse";
import JobsLastErrorsRequest from "@/api/SchedulerAdmin/dataSource/api/scheduler/manager/serverless/i-services/models/dashboard/JobsLastErrorsRequest";

export default class AdapterDashboardService extends BaseAdapterService<null> {
  isInited = ref(false);
  /**
   * список всевозможных статусов
   */

  // private jobsList = ref(Array<JobHistoryRunModel>());

  constructor() {
    super();
    this.init();
    // this.initJobs();
  }

  init() {}

  async getDashboardParameters(
    req: DashboardParametersRequest
  ): Promise<WsResponseModelT<DashboardParametersResponse>> {
    const response = new WsResponseModelT<DashboardParametersResponse>();
    try {
      const res =
        await AdapterDashboardService.api.SchedulerAdmin.DashboardWsController.getDashboardParametersAsync(
          req
        );
      response.IsSuccess = true;
      response.Value = new DashboardParametersResponse(res);
    } catch (error: any) {
      response.IsSuccess = false;
      response.Value = new DashboardParametersResponse();
      this.showError(error?.ErrorMessage || "Неизвестная ошибка");
    }
    return response;
  }
  async getJobsTimelines(
    req: JobsTimelineRequest
  ): Promise<WsResponseModelT<JobsTimelineResponse>> {
    const response = new WsResponseModelT<JobsTimelineResponse>();
    try {
      const res =
        await AdapterDashboardService.api.SchedulerAdmin.DashboardWsController.getJobsTimelinesAsync(
          req
        );
      response.IsSuccess = true;
      response.Value = new JobsTimelineResponse(res);
    } catch (error: any) {
      response.IsSuccess = false;
      response.Value = new JobsTimelineResponse();
      this.showError(error?.ErrorMessage || "Неизвестная ошибка");
    }
    return response;
  }
  async getJobStatusHistory(
    req: GetStatusHistoriesRequest
  ): Promise<WsResponseModelT<GetStatusHistoriesResponse>> {
    const response = new WsResponseModelT<GetStatusHistoriesResponse>();
    try {
      const res =
        await AdapterDashboardService.api.SchedulerAdmin.JobWsController.getJobStatusHistoriesAsync(
          req
        );
      response.IsSuccess = true;
      response.Value = new GetStatusHistoriesResponse(res);
    } catch (error: any) {
      response.IsSuccess = false;
      response.Value = new GetStatusHistoriesResponse();
      this.showError(error?.ErrorMessage || "Неизвестная ошибка");
    }
    return response;
  }
  async getJobsLastErrors(
    req: JobsLastErrorsRequest
  ): Promise<WsResponseModelT<JobsLastErrorsResponse>> {
    const response = new WsResponseModelT<JobsLastErrorsResponse>();
    try {
      const res =
        await AdapterDashboardService.api.SchedulerAdmin.DashboardWsController.getJobsLastErrorsAsync(
          req
        );
      response.IsSuccess = true;
      response.Value = new JobsLastErrorsResponse(res);
    } catch (error: any) {
      response.IsSuccess = false;
      response.Value = new JobsLastErrorsResponse();
      this.showError(error?.ErrorMessage || "Неизвестная ошибка");
    }
    return response;
  }

  /**
   * Получить информацию по задаче по id
   * @param request
   * @returns
   */
  // async getJob(
  //   request: GetJobRequest
  // ): Promise<WsResponseModelT<GetJobResponse>> {
  //   const response = new WsResponseModelT<GetJobResponse>();

  //   try {
  //     const res =
  //       await AdapterJobService.api.SchedulerAdmin.JobWsController.getJobAsync(
  //         request
  //       );

  //     response.IsSuccess = true;
  //     res.LastDateStarted = this.parseValidDate(res.LastDateStarted);
  //     res.NextRunDate = this.parseValidDate(res.NextRunDate);
  //     res.DateCreated = this.parseValidDate(res.DateCreated);
  //     res.DateUpdate = this.parseValidDate(res.DateUpdate);
  //     response.Value = new GetJobResponse(res);
  //   } catch (error: any) {
  //     response.IsSuccess = false;
  //     response.Value = new GetJobResponse();
  //     this.showError(error?.ErrorMessage || "Неизвестная ошибка");
  //   }
  //   return response;
  // }

  // mapGetJobResponseToCreateJobRequest(value: GetJobResponse): CreateJobRequest {
  //   return new CreateJobRequest({
  //     Name: value.Name,
  //     FolderId: value.Id,

  //     TagIds: value.Tags.map((tag) => tag.Id),
  //     DevOpsSettingsId: value.DevOpsSettings.Id,
  //     ArgoCDSettingsId: value.ArgoCDSettings.Id,
  //     DockerImage: value.DockerImage,
  //     IsActive: value.IsActive,
  //     JobConfigurationId: value.JobConfiguration.Id,
  //     JobStatus: value.JobStatus,
  //     JobType: value.JobType,
  //     StandId: value.Stand.Id,
  //     UserCreateId: value.UserCreate.Id,
  //   });
  // };
  /**
   * создать задачу
   *
   */
}
